"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountCloseSession = void 0;
const rxjs_1 = require("rxjs");
const AccountService_1 = require("../AccountService");
const AccountSession_1 = require("./AccountSession");
class AccountCloseSession extends AccountSession_1.AccountSession {
    constructor(params) {
        super(params, AccountService_1.VerifyCodeAction.close_user);
    }
    start(account) {
        this.subscription = (0, rxjs_1.from)(this.params.buAccount.safeCloseAccount({
            action: "close_user",
            account,
            lang: this.params.lang,
        }, this.sessionHandler)).subscribe(this.params.onSuccess, this.params.onError);
    }
}
exports.AccountCloseSession = AccountCloseSession;
